import { TFunction } from "i18next";

const tBase = "orderPageWidgets.orderDetails.receipt.skipReasons";

const SKIP_REASON_FALLBACKS: Record<string, string> = {
	NO_PROVIDER: "Для филиала не настроен провайдер чеков",
	UNSUPPORTED_PAYMENT_TYPE: "Тип оплаты заказа не поддерживается провайдером",
	UNSUPPORTED_ORDER_SOURCE: "Источник заказа не поддерживается провайдером",
};

/** Legacy rows in DB before skipReason model change. */
const LEGACY_SKIP_REASON_FALLBACKS: Record<string, string> = {
	PROVIDER_INACTIVE: SKIP_REASON_FALLBACKS.NO_PROVIDER,
	DISABLED_ON_EXECUTOR: "Электронные чеки отключены у водителя",
	DISABLED_ON_CAR: "Электронные чеки отключены у транспорта",
};

const ALL_SKIP_REASON_FALLBACKS: Record<string, string> = {
	...SKIP_REASON_FALLBACKS,
	...LEGACY_SKIP_REASON_FALLBACKS,
};

export function resolveReceiptSkipReasonMessage(
	t: TFunction,
	skipReason?: string | null,
): string | null {
	if (!skipReason) return null;

	// Was moved to FAILED + lastError; legacy SKIPPED rows may still exist.
	if (skipReason === "MISSING_DRIVER_TAX_ID") return null;

	const fallback = ALL_SKIP_REASON_FALLBACKS[skipReason];
	if (!fallback) return null;

	return t(`${tBase}.${skipReason}`, { defaultValue: fallback });
}
